/**
 * Минимальная форма узла ленты: только те два поля, которые нужны
 * компенсации. Так helper остаётся чистым и проверяемым в node-окружении,
 * где настоящего DOM нет.
 */
export interface ScrollAnchorNode {
  scrollTop: number;
  scrollHeight: number;
}

/**
 * Держит точку чтения на месте, когда «показать ещё» вставляет старые
 * комментарии НАД текущими: браузер сохраняет scrollTop, поэтому без сдвига
 * на прирост высоты лента уезжает вверх и зритель теряет то, что читал.
 *
 * savedScrollHeight снимается до обновления состояния, delta считается
 * после рендера. Неположительная delta означает, что высота не выросла
 * (ничего не догрузилось или лента, наоборот, укоротилась) — тогда трогать
 * скролл не нужно.
 */
export function restoreScrollAfterPrepend(
  node: ScrollAnchorNode,
  savedScrollHeight: number,
): void {
  const delta = node.scrollHeight - savedScrollHeight;
  if (delta <= 0) return;
  node.scrollTop += delta;
}
